<div class="content-wrapper">
  <div class="container-xxl flex-grow-1 container-p-y">
    <mat-drawer-container>
      <mat-drawer [mode]="(screenWidth > 800) ? 'side' : 'over'" [opened]="sideBarOpen" class="aside">
        <app-side-nav *ngIf="this.authService.getRegistredUserDetails().isActive===true"></app-side-nav>
        <app-inactive-side-nav *ngIf="this.authService.getRegistredUserDetails().isActive===false"></app-inactive-side-nav>
      </mat-drawer>

      <mat-drawer-content>
        <app-header (toggleSidebarForMe)="sideBarToggler()"></app-header>
        <router-outlet></router-outlet>
        <app-footer class="footer"></app-footer>
      </mat-drawer-content>
    </mat-drawer-container>
  </div>
</div>